module.exports = __webpack_public_path__ + "media/images/city_img/h_4-77e11156f37359863c6d6bd921adbb8a.jpg";